import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { resetPasswordRequest } from "../requests/auth";
import { useToast } from "../../contexts/toast/Context";

export const useResetPassword = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: (params: { token: string; newPassword: string }) =>
      resetPasswordRequest(params),
    onSuccess: () => {
      showToast("Contraseña actualizada. Ya puedes iniciar sesión.", "success");
      navigate("/auth?reset=success", { replace: true });
    },
    onError: (error: Error) => {
      showToast(error.message, "error");
    },
  });

  return { mutate, isPending };
};
